<template>
  <div class="gat-head">
    <!-- 网站标题 -->
    <div class="head-left">
      <h1 class="head-title">
        <router-link :to="{ name: 'home' }">
          <img :src="Logo.img" alt="AI-training" class="head-title-img" />
        </router-link>
      </h1>
    </div>
    <!-- svg图标组件引用方式 -->
    <div class="head-center">
      <!-- 导航菜单  -->
      <div class="items">
        <span
          v-for="(item, idx) in Nav"
          :key="idx"
          @click="onNewWindow(item, idx)"
          :class="{ dispermit: item.redirect === 'unDo' }"
        >
          <div
            v-if="
              item.show &&
                item.name === 'ai-editor' &&
                editorTypes &&
                editorTypes.length > 0
            "
            :class="['nav-item', originPath === idx ? 'active' : '', item.class,]"
          >
            <!-- 编辑器下拉列表 v-if="editorTypes && editorTypes.length"-->
            <el-dropdown @command="handleCommand" placement="bottom" id="el-dropdown-editor">
              <span class="el-dropdown-link">
                {{ item.label }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu class="editor-dropdown-menu" slot="dropdown">
                <el-dropdown-item
                  v-for="item in editorTypes"
                  :key="item.dictId"
                  :command="item"
                  >{{ item.dictTypeDesc }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <router-link
            v-else-if="item.show && item.menuShow"
            :class="[ 'nav-item', originPath === idx ? 'active' : '', item.class,]"
            :to="{ name: item.redirect }"
            >{{ item.label }}
          </router-link>
        </span>
      </div>
    </div>

    <div class="head-right">
      <div class="search">
        <input type="text" style="display:none" />
        <!-- <input
          class="search-input"
          autocomplete="off"
          type="text"
          placeholder="搜索课程"
          readonly
          v-model="searchVal"
          @mousedown="focusInput($event)"
          @blur="getInput($event)"
          @keyup.enter="getInput($event)"
        /> -->
        <!--placeholder="搜索课程、数据、案例"-->
        <i class="icon-search-box" v-if="false">
          <icon-base class="icon-search" v-bind="Icons.Search">
            <icon-search />
          </icon-base>
        </i>
      </div>
      <div class="tenant-selection" v-show="tenantList.length">
        <!-- 院校（租户）下拉列表 -->
        <el-dropdown
          @command="tenantHandleCommand"
          v-if="tenantList.length"
          placement="bottom"
        >
          <span class="el-dropdown-link">
            {{ currentTenant.tenantName }}
          </span>
          <i class="el-icon-arrow-down el-icon--right"></i>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="(item, index) in tenantList"
              :key="index"
              :command="item"
              >{{ item.tenantName }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <span class="sep"></span>
      <div class="userinfo">
        <el-dropdown @command="selectListCommand" placement="bottom">
          <el-avatar
            id="avatar"
            :size="48"
            :src="accountInfo && accountInfo.photo && hasLogin
              ? (/^(https?:\/\/)/.test(accountInfo.photo) ? accountInfo.photo : photoBaseUrl + accountInfo.photo)
              : User.profile2"
          ></el-avatar>

          <el-dropdown-menu slot="dropdown" v-if="accountInfo.realName">
            <el-dropdown-item :command="'个人空间'">个人空间</el-dropdown-item>
            <el-dropdown-item :command="'回收站'">回收站</el-dropdown-item>
            <el-dropdown-item :command="'账号设置'">账号设置</el-dropdown-item>
            <el-dropdown-item :command="'退出登录'">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <div class="user-info-wrap">
          <tooltip-box
            v-if="accountInfo.realName"
            :textRef="'realName'"
            :textRow="1"
            :textWidth="'80px'"
            :textName="accountInfo.realName"
            :placement="'bottom'"
            :tooltipShow="false"
          ></tooltip-box>
          <span v-if="roleNames" class="role-name">{{ roleNames }}</span>
        </div>
        <slot name="right-button">
          <!-- <button
            type="button"
            class="el-button el-button--primary el-button--medium ml20"
            @click="activeCreatePopup"
            v-if="hasLogin && creationShow && userRole !== 2"
          >
            <span>马上创作</span>
          </button> -->
          <button
            type="button"
            class="el-button--primary el-button--medium ml20"
            @click.stop="activeLoginPopup"
            v-if="!hasLogin"
          >
            <span>登录</span>
          </button>
        </slot>
      </div>
    </div>

    <!-- 登录/注册 组件 -->
    <div>
      <Login ref="gtaLogin"></Login>
    </div>
  </div>
</template>

<script>
import IconSearch from '@/components/icons/typography/Search'
import IconPopupClose from '@/components/icons/typography/PopupClose'
import TooltipBox from '@/components/common/TooltipBox'
import Login from '@/components/common/Login'
import LOGIN from '@/axios/login/login'
import bus from '@/utils/bus'

import { mapGetters, mapActions } from 'vuex'

/* eslint-disable */
let tag = process.env.VUE_APP_TAG
let NavMenuStatus = getEnv(tag).NavMenuStatus

export default {
  name: 'gat-head',
  components: { IconSearch, IconPopupClose /*GatPopup*/, Login, TooltipBox },
  data() {
    return {
      photoBaseUrl: window.gtaAiConfig.photoDomain, // 新UC头像基地址
      token: null,
      searchCoursePage: false,
      originPath: null,
      experianceAI: window.gtaAiConfig.EXPERIENCE_AI,
      currentTenant: {
        // 选中租户
        tenantName: '',
        tenantId: '',
      },
      tenantList: [], // 租户列表
      searchVal: '',
      // accountInfo: {},
      userType: '', //保存用户类型
      loginName: '',
      Password: '',
      loginForm: {
        loginName: '',
        Password: '',
      },
      code: '', //验证码
      timer: null,
      codeTimer: 120, //时间计时器
      codeVal: '', //验证码状态
      accountVal: false, //账后是否注册的状态
      signupForm: {
        loginName: '',
        Password: '',
        code: '',
      },
      signupEmailForm: {
        loginName: '',
        Password: '',
        code: '',
      },
      safeForm: {
        loginName: '',
        Password: '',
        code: '',
      },
      saveNextVal: false,
      resetForm: {
        Password: '',
        Password2: '',
      },
      resetError: false,
      passStatus: null, //设置密码的验证状态
      pagination: {
        PageSize: 8,
        PageIndex: 1,
      },
      QRCode: require('../../../public/images/QRCode/QRCode.png'),
      Logo: {
        img: require('../../../public/images/logo.png'),
      },
      User: {
        profile: null,
        profile2: require('../../../public/images/profile03.png'),
      },
      // 马上创作指令字符串
      createCmdString: '',
      // 首页、我的项目、模型训练、严选课程、热门赛事、技能认证
      Nav: [
        {
          name: 'home',
          menuShow: true,
          show: NavMenuStatus.home,
          class: 'home-item',
          label: '首页',
          redirect: 'home',
          path: '/home',
        },
        {
          name: 'my_project',
          menuShow: true,
          show: NavMenuStatus.training,
          label: '实训中心',
          class: 'training-item',
          redirect: 'projects-training-project',
          path: '/training/',
        },
        {
          name: 'model_training',
          menuShow: true,
          show: NavMenuStatus.modelTraining,
          class: 'model-training-item',
          label: '模型训练',
          redirect: 'pretrain',
          path: '/pretrain/',
        },
        {
          name: 'ai-editor',
          menuShow: true,
          show: NavMenuStatus.aiEditor,
          class: 'ai-editor-item',
          label: '编辑器',
          redirect: 'ai-editor',
          path: 'aiTEditor|projects',
        },

        {
          name: 'model_training2',
          menuShow: true,
          show: NavMenuStatus.industralApplication,
          class: 'apply-item',
          label: '行业应用',
          redirect: 'application-index',
          path: '/industral/application',
        },
        {
          name: 'model_training4',
          menuShow: true,
          show: NavMenuStatus.experienceAi,
          class: 'experience-item',
          label: 'AI-体验馆',
          redirect: '',
          path: '/experience/ai',
        },
        {
          name: 'model_training',
          menuShow: true,
          show: NavMenuStatus.teaching,
          class: 'teaching-item',
          label: '教学中心',
          redirect: '',
          path: '/teaching',
        },
        // {
        //   name: "dataset-lobby",
        //   menuShow: true,
        //   class:'dataset-lobby-item',
        //   label: "数据集大厅",
        //   redirect: "dataset-lobby",
        //   path: "/datasetlobby"
        // },
        // {
        //   name: "hardware-center",
        //   menuShow: true,
        //   class:'hardware-item',
        //   label: "硬件管理",
        //   redirect: "hardware-center",
        //   path: "/hardwareCenter"
        // },
      ],
      Icons: {
        Search: {
          iconName: '搜索',
          viewBox: '0 0 20 20',
          width: '20',
          height: '20',
        },
        PopupClose: {
          iconName: '关闭',
          viewBox: '0 0 14 14',
          width: '14',
          height: '14',
          // iconColor: "#fff"
        },
      },
      popupActive: '',
      checked: true,
      phoneChecked: true,
      emailChecked: true,
      LoginTeenDays: true,
      isLogin: true,
      isPhone: true,
      isSafe: false,
      isReset: false,
      hasLogin: null,
      roleNames: null,
      userRole: 1,
    }
  },
  props: {
    openLogin: {
      type: String,
      default: null,
    },
    creationShow: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    accountInfo: {
      get(val) {
        let accountInfo = JSON.parse(JSON.stringify(this.$store.state.accountInfo))
        return accountInfo
      },
      set(val) {
        this.User.profile = val.UserImgUrl
      },
    },
    editorTypes: {
      get(val) {
        let editorTypeList = [...this.editorTypeList]
        let editorTypeArr = this.editorTypeArr
        if (this.hasLogin) {
          let list = editorTypeList.filter((item) => {
            let hasAttr = false
            editorTypeArr.some((item2) => {
              if (new RegExp(item2.menuName).test(item.dictTypeDesc)) {
                hasAttr = true
                return
              }
            })
            return hasAttr
          })
          return list
        } else {
          return this.editorTypeList
        }
      },
      set(val) {},
    },
    ...mapGetters([
      'appId',
      'smsUrl',
      'smsPath',
      'teachingCourseId',
      'menuList',
      'editorTypeArr',
      'editorTypeList',
    ]),
  },

  watch: {
    $route: function(to, from) {},
    openLogin(newVal) {
      if (newVal == 'login') {
        this.activeLoginPopup();
      }
    },
    'currentTenant.tenantId': {
      handler(val) {
        if (val) {
          this.$store.state.tenantId = val;
          sessionStorage.tenantId = val;
          this.getMenuList();
          this.getDataSetType({ dictTypeCode: 'EditorType' });

          //不同租户对应的角色
          let role = 1,
            userTenantRoleList = this.accountInfo.userTenantRoleList;
          if (userTenantRoleList && userTenantRoleList.length) {
            userTenantRoleList.forEach((item) => {
              if (item.tenantId == val) {
                this.roleNames = item.roleName;
              }
            })
            if (/老师/.test(this.roleNames)) {
              role = 1;
            } else if (/学生/.test(this.roleNames)) {
              role = 2;
            } else if (/校管理员/.test(this.roleNames)) {
              role = 3;
            } else if (/超级管理员/.test(this.roleNames)) {
              role = 4;
            }
            this.userRole = role;
            sessionStorage.userRole = role;
            this.$store.commit('setUserRole', role);
            this.$store.state.accountInfo.roleName = this.roleNames;
            sessionStorage.setItem('accountInfo', JSON.stringify(this.$store.state.accountInfo))
          }
        }
      },
      deep: true,
      immediate: true,
    },
    menuList: {
      handler(menuList) {
        if (menuList) {
          this.Nav.map((ite) => {
            ite.menuShow = false
            return ite
          })
          // menuList和Nav数据转换
          menuList.forEach((item) => {
            this.Nav.forEach((ite) => {
              if (item.menuName == ite.label) {
                ite.menuShow = true
              }
            })
          })
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    // 调用头部获取登录信息
    this.getHasLogin()
  },
  async mounted() {
    let that = this
    bus.$on('quit', () => {
      that.popupActive = 'login'
    })
    //处理路由路径
    this.originPathHandle()
    if (!sessionStorage.editorTypeList) {
      // 获取编辑器
      await this.getDataSetType({ dictTypeCode: 'EditorType' })
      //获取模型类型
      this.getDataSetType({ dictTypeCode: 'ModelType' })
    }
    if (localStorage.loginType) {
      localStorage.loginType = ''
      this.$refs.gtaLogin.quitLogin() // 退出登录
      this.activeLoginPopup() // 登录弹窗
    }

    let avatar = document.getElementById('avatar')
    avatar.onclick = () => {
      this.toLogin()
    }
  },
  updated() {},
  destroyed() {},
  methods: {
    // 调用头部获取登录信息
    getHasLogin() {
      this.createCmdString = 'create'
      let hasLogin = sessionStorage.getItem('hasLogin')
      if (!hasLogin) {
        this.hasLogin = false
      } else {
        this.hasLogin = Boolean(hasLogin)
        if (hasLogin) {
          this.userType = this.$store.state.userType
          if (this.accountInfo) this.User.profile = this.accountInfo.UserImgUrl
          this.tenantList = JSON.parse(sessionStorage.tenantList) || []
          this.currentTenant = JSON.parse(sessionStorage.currentTenant) || {
            tenantName: '',
            tenantId: '',
          }
        }
      }
    },
    ...mapActions(['getDataSetType', 'getMenuList', 'initMenuList']),
    // 选择编辑器
    handleCommand(val) {
      if (val) {
        let editorId = val.dictId,
          editorType

        this.editorTypes.forEach((item) => {
          if (item.dictId == editorId) {
            editorType = item.dictTypeDesc
          }
        })
        if (/(?=.*AI-T).*(?=.积木模式)/i.test(editorType)) {
          this.$router.push({
            name: 'ai-editor',
            query: {
              editorId: editorId,
              mode: 'code',
            },
          })
        } else if (/AI-T/i.test(editorType)) {
          this.$router.push({
            name: 'ai-python-editor',
            query: {
              editorId: editorId,
            },
          })
        } else if (/(海龟|基础积木)/g.test(editorType)) {
          this.$router.push({
            name: 'baseBlock-editor',
            query: {
              editorId: editorId,
            },
          })
        } else if (/小智/g.test(editorType)) {
          this.$router.push({
            name: 'hardwareBlock-editor-B',
            query: {
              editorId: editorId,
            },
          })
        } else if (/小聪/g.test(editorType)) {
          this.$router.push({
            name: 'hardwareBlock-editor',
            query: {
              editorId: editorId,
            },
          })
        } else if (/python/g.test(editorType)) {
          this.$router.push({
            name: 'python-editor',
            query: {
              editorId: editorId,
            },
          })
        }
      }
    },
    selectListCommand(val) {
      if (val === '个人空间') {
        this.JumpPersonal();
      } else if (val === '回收站') {
        this.JumpRecycleBin();
      } else if (val === '账号设置') {
        this.JumpSetting();
      } else if (val === '退出登录') {
        this.$refs.gtaLogin.quitLogin();
      }
    },
    // 选择院校
    async tenantHandleCommand(val) {
      this.currentTenant = val;
      await this.updateTenantBehavior(val); // 记录切换租户行为
      setTimeout(() => {
        this.getLastTimeTenant(); //切换租户
      }, 100)

      setTimeout(() => {
        this.$router.push({ name: 'home', query: {} });
      }, 200)
    },
    //跳转新窗口
    onNewWindow(item, index) {
      let { label } = item
      let { userRole, appId, smsUrl, smsPath, currentTenant } = this
      let token
      let reg_http = /^(https?:\/\/)/
      if (sessionStorage.token) {
        token = sessionStorage.token.replace(/"/g, '')
      } else {
        token = this.token
      }

      let courseId = this.teachingCourseId

      switch (label) {
        case 'AI-体验馆': {
          //  this.$router.push("/experian/index");
          // const { href } = this.$router.resolve({
          //   path: `/experian/index`
          // });
          // window.open(href, "_blank");
          // window.open("../../../modules/experianceAI/index.html")//原来的路由导航
          window.open(window.gtaAiConfig.experienceUrl) //原来的路由导航
          break
        }
        case '教学中心': {
          if (userRole != 2) {
            if (currentTenant && typeof currentTenant == 'object') {
              let { sitePath } = currentTenant
              if (sitePath) {
                reg_http.test(sitePath)
                  ? (smsUrl = sitePath + '/login')
                  : (smsUrl = 'https://' + sitePath + '/login')
              }
            }
            //教师用户
            let targetUrl =
              smsUrl +
              '?token=' +
              token +
              '&appId=' +
              appId +
              '&redirect=' +
              smsPath +
              '?courseId=' +
              courseId
            // console.log('targetUrl', targetUrl)
            try {
              window.open(targetUrl)
            } catch (e) {
              this.$message.error('跳转失败：站点路径路径无效')
            }
          } else {
            //学生用户
            this.$router.push({ name: 'teaching-center-code' })
          }
          break
        }
        default:
          break
      }
    },
    originPathHandle() {
      let { Nav } = this
      let pathname = window.location.pathname
      let isMenu = false
      // let idx
      Nav.forEach((item, index) => {
        let path = new RegExp(item.path)
        if (pathname == '/') {
          //首页
          this.originPath = 0
          isMenu = true
        } else if ( item.path != '/home' && path.test(pathname)) {
          this.originPath = index
           isMenu = true
        }
      })

      if (!isMenu) {
        this.originPath = null
      }
    },

    // 将马上创作进行分发事件
    activeCreatePopup(evt) {
      if (this.$route.name !== 'projects-training-project') {
        var createCmdString = this.createCmdString

        this.$router.push({
          name: 'ai-editor',
          // name: "projects-training-project",
          // params: { operate: createCmdString }
        })
        return
      }
      this.$emit('active-create', evt)
    },

    //登录弹窗
    activeLoginPopup() {
      this.$refs.gtaLogin.activeLoginPopup()
    },
    // // // 取消弹窗
    // cancelPopup() {
    //   this.popupActive = ''
    //   this.isLogin = false
    //   this.isPhone = false
    //   this.isSafe = false
    //   this.isReset = false
    //   this.$emit('cancelLogin')
    //   try {
    //     this.$refs.loginForm.clearValidate()
    //   } catch (e) {
    //     console.log(e)
    //   }
    // },

    //账号设置跳转
    JumpSetting() {
      this.$router.push({ name: 'account-setting' })
    },
    //回收站跳转
    JumpRecycleBin() {
      this.$router.push({ name: 'recycle-bin' })
    },
    //个人中心跳转6000
    JumpPersonal() {
      this.$router.push({ name: 'projects-list' })
    },

    //登陆状态处理函数
    loginStatusHandler(data) {
      if (data) {
        //登录时设置
        this.User.profile = JSON.parse(
          sessionStorage.getItem('accountInfo')
        ).UserImgUrl
        this.hasLogin = true
        self.token = data.token
        self.accountInfo = data.data
        this.getUserTenantList() // 获取用户所属的租户列表
        //获取模型类型
        this.getDataSetType({ dictTypeCode: 'ModelType' })
      } else {
        //退出登录时设置
        this.token = ''
        this.roleNames = ''
        this.hasLogin = false
        this.accountInfo.realName = ''
        this.accountInfo.roleNames = ''
        this.tenantList = []
        sessionStorage.menuList = ''
        sessionStorage.tenantId = ''
        this.$store.state.tenantId = ''
        this.currentTenant = {
          tenantName: '',
          tenantId: '',
        }
        // sessionStorage.setItem('currentTenant', '') //null,false,'',
        // sessionStorage.setItem('tenantList', '') //null,false,'',
        this.initMenuList()
        this.getDataSetType({ dictTypeCode: 'EditorType' })
      }
    },

    // 获取用户所属的租户列表
    getUserTenantList() {
      LOGIN.getUserTenantList().then((res) => {
        if (res && res.isSuccess && res.data) {
          this.tenantList = res.data
          sessionStorage.tenantList = JSON.stringify(res.data)
          this.getLastTimeTenant()
          // 防止手动清空浏览器数据，接口请求成功token未失效，为登录状态
          this.hasLogin = true
          sessionStorage.setItem('hasLogin', true)
        }
      })
    },
    // 获取用户上次选择的租户
    getLastTimeTenant() {
      LOGIN.getLastTimeTenant().then((res) => {
        if (res && res.isSuccess && res.data) {
          this.currentTenant = {
            tenantId: res.data.tenantId, // 租户id
            tenantName: res.data.tenantName, // 租户名称
            sitePath: res.data.sitePath || '', // 租户对应的站点路径
          }
          sessionStorage.currentTenant = JSON.stringify(this.currentTenant)
        } else {
          // let tenant = this.tenantList[0]
          // this.currentTenant = tenant
          // sessionStorage.currentTenant = JSON.stringify(this.currentTenant)
          // this.updateTenantBehavior(tenant)
        }
      })
    },
    // 记录切换租户行为
    updateTenantBehavior(val) {
      let data = {
        // behaviorId: '', // 行为id
        tenantId: val.tenantId, // 租户id
        tenantName: val.tenantName, // 租户名称
      }
      return LOGIN.updateTenantBehavior(data).then((res) => {
        if (res && res.isSuccess && res.data) {
          this.currentTenant = res.data
        }
      })
    },

    toLogin() {
      if (!this.hasLogin) {
        this.activeLoginPopup()
      }
    },
    focusInput(event) {
      if (!this.hasLogin) {
        this.popupActive = 'login'
        let readonly = event.currentTarget.getAttribute('readonly')
        if (!readonly) event.currentTarget.setAttribute('readonly')
        return
      }
      event.currentTarget.removeAttribute('readonly')
    },
  }, //end
}
</script>

<style lang="scss" scoped>
@import './GatHead.scss';
</style>
